const initialState = {
  marketTrends: null,
  overviewResult: '',
  industryName: '',
  url: '',
  loading: false,
  error: null
};

const marketTrendsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MARKET_TRENDS':
      return {
        ...state,
        marketTrends: action.payload,
        overviewResult: action.payload.overview_result || '',
        industryName: action.payload.industry_name || '',
        url: action.payload.url || '',
        loading: false,
        error: action.payload.error
      };
    case 'SET_LOADING_ANSWER':
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};

export default marketTrendsReducer; 